/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo numeric textbox
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var NumericTextBox = kendo.ui.NumericTextBox;
    if (!NumericTextBox || NumericTextBox.updated) return;

    var NS = ".kendoNumericTextBox",
        proxy = $.proxy,
        support = kendo.support,
        Widget = kendo.ui.Widget,
        NO_SPINNERS = "no-spinners",
        PLACEHOLDER = "placeholder",
        NULL = null,
        POINT = ".",
        HIDDEN = "hidden",
        FOCUSED = "k-state-focused",
        DISABLED_ARROW = "arrow-disabled",
        ROUND_ARROWS_CLASS = "k-round-arrows",

        DEFAULT = 'k-state-default',
        SELECTED = 'k-state-selected',
        DISABLED = 'disabled',
        STATEDISABLED = 'k-state-disabled',
        READONLY = 'readonly',
        STATEREADONLY = "k-state-readonly",
        MOUSELEAVE = 'mouseleave' + NS,
        HOVEREVENTS = 'mouseenter' + NS + ' ' + MOUSELEAVE,
        TOUCHEVENTS = "touchend" + NS + " click" + NS,

        AVATAR = "avatar",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        VISIBLE = ":visible",
        SIZE_2_INDEX = 1,
        SIZE_5_INDEX = 4,
        FIRST_TIMEOUT = 500,
        NEXT_TIMEOUT = 50;

    /**
     * Used in NumericTextBox.
     */
    function caret(element, position) {
        var range,
            isPosition = position !== undefined;
        // try - catch due to http://stackoverflow.com/questions/22381837/
        try {
            if (document.selection) {
                if ($(element).is(VISIBLE)) element.focus();
                range = document.selection.createRange();
                if (isPosition) {
                    range.move("character", position);
                    range.select();
                } else {
                    var rangeElement = element.createTextRange(),
                        rangeDuplicated = rangeElement.duplicate();
                    rangeElement.moveToBookmark(range.getBookmark());
                    rangeDuplicated.setEndPoint("EndToStart", rangeElement);
                    position = rangeDuplicated.text.length;
                }
            } else if (element.selectionStart !== undefined) {
                if (isPosition) {
                    element.focus();
                    element.setSelectionRange(position, position);
                } else {
                    position = element.selectionStart;
                }
            }
        } catch (e) { }
        return position;
    }

    /**
     * To be able to apply click events also on wrapper we need to modify the
     * _click() method.
     */
    function numericTextBoxClick() {
        var self = this;
        if (self.wrapper.hasClass(ROUND_ARROWS_CLASS) && support.click === "touchend") {
            return;
        }
        clearTimeout(self._focusing);
        self._focusing = setTimeout(function () {
            var input = /* event.target */ self.element[0],
                idx = caret(input),
                value = input.value.substring(0, idx),
                format = self._format(self.options.format),
                group = format[","],
                groupRegExp,
                extractRegExp,
                result,
                caretPosition = 0;

            if (group) {
                groupRegExp = new RegExp('\\' + group, 'g');
                extractRegExp = new RegExp('([\\d\\' + group + ']+)(\\' + format[POINT] + ')?(\\d+)?');
            }
            if (extractRegExp) {
                result = extractRegExp.exec(value);
            }
            if (result) {
                caretPosition = result[0].replace(groupRegExp, "").length;
                if (value.indexOf("(") !== -1 && self._value < 0) {
                    caretPosition++;
                }
            }
            self._focusin();
            caret(input, caretPosition);
        });
    }

    /**
     * Apply states rather on main wrapper.
     */
    function numericTextBoxFocusIn() {
        var self = this;
        if (self.wrapper.hasClass(ROUND_ARROWS_CLASS) && support.click === "touchend") {
            return;
        }
        self.info(
        "_focusin(), setting focus on element " +
        self.describeElement(self.element[0])
        );
        self.wrapper.addClass(FOCUSED);
        self._toggleText(false);
        self.element[0].focus();
    }

    function numericTextBoxFocusOut() {
        var self = this;
        self.info("_focusout()");
        clearTimeout(self._focusing);
        self.wrapper.removeClass(FOCUSED);
        self._blur();
        self._removeInvalidState();
    }

    /**
     * Switches formatted text and the main input elements
     * visibility according to component focus. When it has focus,
     * formatted value should be hidden.
     */
    function numericTextBoxToggleText(showFormattedText) {
        var self = this;
        // TODO : tabindexes & focus events ?
        self.info("_toggleText(), showFormattedText = %s", showFormattedText);
        if (showFormattedText) {
            self._text.removeClass(HIDDEN);
            self.element.addClass(HIDDEN);
        } else {
            self._text.addClass(HIDDEN);
            self.element.removeClass(HIDDEN);
        }
        // TODO : remove some remains from previous solution; cleaner ?
        self._text.css("display", "");
        self.element.css("display", "");
    }

    function numericTextBoxUpdate(value) {
        var self = this,
            options = self.options,
            format = options.format,
            decimals = options.decimals,
            culture = self._culture(),
            numberFormat = self._format(format, culture);
        self.info("_update(), value : %s", value);
        if (decimals === NULL) decimals = numberFormat.decimals;
        value = self._parse(value, culture);
        var isNotNull = value !== NULL;
        if (isNotNull) value = parseFloat(value.toFixed(decimals));
        self._value = value = self._adjust(value);
        var formatted = kendo.toString(value, format, culture);
        // update helper input here, not in _placeholder()
        self._text.val(formatted);
        // reverse logic for placeholder switching
        self._placeholder(!formatted);
        self.element
            .val(
            isNotNull ?
                value.toString().replace(POINT, numberFormat[POINT]) :
                ""
            )
            .attr("aria-valuenow", value);
        // update arrows/buttons
        updateButtons(self);
    }

    function toggleArrows(self) {
        if (self.wrapper) {
            var isMobileBp = false;
            if (self.options.spinners && typeof ori != "undefined" && typeof ori.device != "undefined") {
                var index = ori.device.activeBreakpoint ? ori.device.activeBreakpoint.index : SIZE_5_INDEX;
                isMobileBp = index <= SIZE_2_INDEX;
            }
            self.wrapper.toggleClass(NO_SPINNERS, !self.options.spinners || isMobileBp);
        }
    }

    function numericTextBoxArrows() {
        var self = this,
            _release = function () {
                clearTimeout(self._spinning);
                arrows.removeClass(SELECTED);
            },
            options = self.options,
            spinners = options.spinners,
            element = self.element,
            arrows = element.siblings('.k-icon');
        if (!arrows[0]) {
            if (self.options.theme == "roundArrows") {
                arrows = $(roundButtonHtml('increase', 'add', options.upArrowText) + roundButtonHtml('decrease', 'minimize', options.downArrowText)).insertAfter(element);
            } else {
                arrows = $(buttonHtml('increase', options.upArrowText) + buttonHtml('decrease', options.downArrowText)).insertAfter(element);
                arrows.wrapAll('<span class="k-select"/>');
            }
        }
        if (!spinners) {
            arrows.parent().toggle(spinners);
            self._inputWrapper.addClass('k-expand-padding');
        }
        self._upArrow = arrows.eq(0);
        self._upArrowEventHandler = new kendo.UserEvents(self._upArrow, { release: _release });
        self._downArrow = arrows.eq(1);
        self._downArrowEventHandler = new kendo.UserEvents(self._downArrow, { release: _release });
    }

    /**
     * Overwrite of original editable now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function numericTextBoxEditable(options) {
        var self = this,
            element = self.element,
            disable = options.disable,
            readonly = options.readonly,
            text = self._text.add(element),
            wrapper = self._inputWrapper.off(HOVEREVENTS),
            topWrapper = self.wrapper.off(HOVEREVENTS);
        self._toggleText(true);
        self._upArrowEventHandler.unbind('press');
        self._downArrowEventHandler.unbind('press');
        element.off('keydown' + NS).off('keypress' + NS).off('keyup' + NS).off('paste' + NS);
        if (self.options.theme == "roundArrows") {
            wrapper.parent().addClass(ROUND_ARROWS_CLASS);
        }
        if (!readonly && !disable) {
            wrapper.removeClass(STATEREADONLY).removeClass(STATEDISABLED);
            topWrapper.addClass(DEFAULT).removeClass(STATEREADONLY).removeClass(STATEDISABLED).on(HOVEREVENTS, self._toggleHover).on(TOUCHEVENTS, proxy(self._click, self));
            text.prop(DISABLED, false).prop(READONLY, false);
            self._upArrowEventHandler.bind('press', function (e) {
                e.preventDefault();
                self._spin(1);
                self._upArrow.addClass(SELECTED);
            });
            self._downArrowEventHandler.bind('press', function (e) {
                e.preventDefault();
                self._spin(-1);
                self._downArrow.addClass(SELECTED);
            });
            self.element.on('keydown' + NS, proxy(self._keydown, self)).on('keypress' + NS, proxy(self._keypress, self)).on('keyup' + NS, proxy(self._keyup, self)).on('paste' + NS, proxy(self._paste, self));
        } else {
            if (readonly) {
                wrapper.removeClass(DEFAULT).removeClass(STATEDISABLED);
                topWrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED);
            }
            if (disable) {
                wrapper.removeClass(DEFAULT).removeClass(STATEREADONLY);
                topWrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            text.prop(DISABLED, disable).prop(READONLY, readonly);
        }
    }

    function buttonHtml(direction, text) {
        var className = 'k-i-arrow-' + (direction === 'increase' ? '60-up' : '60-down');
        return '<span unselectable="on" class="k-link k-link-' + direction + '" aria-label="' + text + '" title="' + text + '">' + '<span unselectable="on" class="k-icon ' + className + '"></span>' + '</span>';
    }

    function roundButtonHtml(direction, iconClass, text) {
        return '<span unselectable="on" class="k-link k-link-' + direction + ' round-' + direction + ' v-icon-'  + iconClass + '" aria-label="' + text + '" title="' + text + '"></span>';
    }

    function updateButtons(instance) {
        var val = instance.value();
        if (typeof val === "undefined") {
            return;
        }

        var min = instance.min();
        var max = instance.max();
        if (min !== null) {
            var decrease = instance.wrapper.find(".k-link-decrease");
            if (decrease) {
                decrease.toggleClass(DISABLED_ARROW, min >= val);
            }
        }
        if (max !== null) {
            var increase = instance.wrapper.find(".k-link-increase");
            if (increase) {
                increase.toggleClass(DISABLED_ARROW, max <= val);
            }
        }
    }

    function _spin(step, timeout) {
        var self = this;

        if (self.options.autoSpinner) {
            timeout = timeout || FIRST_TIMEOUT;
            self.info("_spin() after timeout %s ms", timeout);

            clearTimeout( self._spinning );
            self._spinning = setTimeout(function() {
                self._spin(step, NEXT_TIMEOUT);
            }, timeout );
        }

        self._step(step);
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldNumericTextBoxInit = NumericTextBox.fn.init,
        newNumericTextBoxInit = function (element, options) {
            var self = this,
                $element = $(element),
                isOriDevice = typeof ori != "undefined" && Boolean(ori.device);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "numerictextbox", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            if (options.readonly === undefined)
                options.readonly = $element.is("[readonly]");
            if (options.autoSpinner === undefined)
                options.autoSpinner = true;
            // remove avatar class before the wrapper gets created
            $element.removeClass(AVATAR);
            // call original constructor
            oldNumericTextBoxInit.call(self, element, options);
            // update placeholder in options to be sure
            self.options.placeholder = self.options.placeholder || self.element.attr(PLACEHOLDER);
            // remember title text - needed for various description UI types
            // execute with caution to not remove the title by mistake
            self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
            self.element.removeAttr(ATTR_TITLE);
            // update validation UI type in options to be sure
            self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);
            // monitor keystrokes for placeholder
            if (!support.placeholder && typeof self._keyup == "function")
                self.element.on("keyup" + NS, proxy(self._keyup, self));
            // main widget wrapper custom styles
            kendo.moveCustomStylesToWrapper.call(self);
            kendo.moveRwdDataToWrapper.call(self);
            // append spinners class for easier styling
            if (isOriDevice) {
                ori.device.bindResize(function () { toggleArrows(self); });
            }
            toggleArrows(self);
            // placeholder update
            if (!support.placeholder) self._text.prop(PLACEHOLDER, "");
            // touch number keyboard - currently checking the touch support on ori.device
            // and in kendo.support as a fallback
            // 2017-06-28 removed because it breaks inserting decimals in cultures with decimal comma
            //if (support.input.number && ((isOriDevice && ori.device.isTouch) || support.touch)) {
            //    self.element.attr( "type", "number" );
            //}
            // update title / tooltip popups
            Widget.fn.descriptionUi.call(self);
            // remove input class from wrapper for easier styling
            self.wrapper.removeClass("k-input");
        };

    NumericTextBox = NumericTextBox.extend({
        // new init
        init: newNumericTextBoxInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions(),
        // updated methods
        _click: numericTextBoxClick,
        _focusin: numericTextBoxFocusIn,
        _focusout: numericTextBoxFocusOut,
        _spin: _spin,
        _toggleText: numericTextBoxToggleText,
        _update: numericTextBoxUpdate,
        _editable: numericTextBoxEditable,
        _arrows: numericTextBoxArrows
    });

    kendo.updatePlaceholderLogic(NumericTextBox);

    NumericTextBox.updated = true;

    kendo.ui.plugin(NumericTextBox);

})(window.kendo.jQuery);
